import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "../features/authSlice";
import { cartransferSlice } from "../features/cartransferSlice";

export default configureStore({
  reducer: {
    auth: authSlice.reducer,
    cartransfer: cartransferSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["cartransfer/setEntity"],
        ignoredPaths: ["cartransfer"],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});
